import React from "react";
import { Layout } from "antd";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppRoutes from "../../config/AppRoutes";
import "./Application.css";

const { Content } = Layout;

const Application = () => {
  return (
    <BrowserRouter>
      {/* <Layout> */}
      {/* <HeaderComponent /> */}
      <Layout>
        <Content
          style={{
            // marginTop: "60px",
            minHeight: "100vh",
          }}
        >
          <Routes>
            {AppRoutes.map((route) => (
              <Route
                exact={route.exact}
                path={route.path}
                element={route.component}
                key={route.key}
              />
            ))}
          </Routes>
        </Content>
      </Layout>
      {/* </Layout> */}
    </BrowserRouter>
  );
};
export default Application;
